import React, { useEffect, useState } from 'react';

const Cover = () => {
  const [visibleElements, setVisibleElements] = useState([false, false, false, false]); // State for visibility of elements

  useEffect(() => {
    // Function to trigger fade-up effect for each element
    const fadeInElements = () => {
      const timer = setTimeout(() => {
        setVisibleElements([true, false, false, false]); // Fade in first element
      }, 1000);

      const secondTimer = setTimeout(() => {
        setVisibleElements([true, true, false, false]); // Fade in second element
      }, 1100); // 200ms delay

      const thirdTimer = setTimeout(() => {
        setVisibleElements([true, true, true, false]); // Fade in third element
      }, 1200); // Another 200ms delay

      const fourthTimer = setTimeout(() => {
        setVisibleElements([true, true, true, true]); // Fade in fourth element
      }, 1300); // Another 200ms delay

      return () => {
        clearTimeout(timer);
        clearTimeout(secondTimer);
        clearTimeout(thirdTimer);
        clearTimeout(fourthTimer);
      };
    };

    fadeInElements(); // Start the fade-in effect
  }, []);

  useEffect(() => {
    var typed = new window.Typed(".auto-type", {
      strings: ["Software", "Web", "Game"],
      typeSpeed: 100,
      backSpeed: 100,
      loop: true
    });

    return () => {
      typed.destroy(); // Cleanup on unmount
    };
  }, []);

  return (
    <section id="cover">
      <div className="container cover">
        <div>
          <h1 id="description" className={`fade-up ${visibleElements[0] ? "visible" : ""}`}>Hi, my name is</h1>
        </div>
        <div>
          <h1 id="cover-name" className={`fade-up ${visibleElements[1] ? "visible" : ""}`}>Chris Cheung.</h1>
        </div>
        <div>
          <h1 id="intro" className={`fade-up ${visibleElements[2] ? "visible" : ""}`}>
            I develop <span className="auto-type"></span>.
          </h1>
        </div>
        <div>
          <p id="info" className={`fade-up ${visibleElements[3] ? "visible" : ""}`}>
            I am a graduate of the Chinese University of Hong Kong with a major in Computer Science. I have developed several projects, including software applications, websites, and games. Currently, I am seeking challenging roles in these fields.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Cover;